"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBan(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.626-5.374 12-12 12S0 18.626 0 12C0 5.372 5.373 0 12 0zM4.076 5.16A10.427 10.427 0 001.532 12c0 5.78 4.688 10.468 10.468 10.468 2.614 0 5.005-.959 6.84-2.544zM12 1.531c-2.615 0-5.005.958-6.84 2.543L19.924 18.84A10.427 10.427 0 0022.468 12c0-5.782-4.687-10.468-10.468-10.468z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBan;
exports.default = _default;